import { createFileRoute } from "@tanstack/react-router";
import { RegressivasPanelPublicPage } from "@/paginas/pg_regressivas/regressivas-panel-public";

export const Route = createFileRoute("/regressivas-panel-public")({
  component: RegressivasPanelPublicPage,
});
